import AllMail from '../allMail';

export default function AllMailPage() {
  return (
    <AllMail />
  );
}
